import styled from 'styled-components';

export const FormFieldItem = styled.div`
  margin-bottom: 1rem;
`;
